var rx = /^(\d{1,2}):(\d{1,2})(:(\d{1,2})(.(\d{1,3}))?)?$/;
export var oneSecond = 1000;
export var oneMinute = 60 * oneSecond;
export var oneHour = 60 * oneMinute;
export var oneDay = 24 * oneHour;
export function dig(value, length) {
    return value.toString(10).padStart(length, '0');
}
export function getTimeParts(timestamp) {
    var time = getPureTime(timestamp);
    var hours = ~~(time / oneHour);
    var fullHours = hours * oneHour;
    var minutes = ~~((time - fullHours) / oneMinute);
    var fullMinutes = fullHours + minutes * oneMinute;
    var seconds = ~~((time - fullMinutes) / oneSecond);
    var fullSeconds = fullMinutes + seconds * oneSecond;
    var milliseconds = time - fullSeconds;
    return [hours, minutes, seconds, milliseconds];
}
export function toTimeString(timestamp) {
    var _a = getTimeParts(timestamp), hours = _a[0], minutes = _a[1], seconds = _a[2], milliseconds = _a[3];
    return "".concat(dig(hours, 2), ":").concat(dig(minutes, 2), ":").concat(dig(seconds, 2), ".").concat(dig(milliseconds, 3));
}
export function getPureTime(timestamp) {
    if (typeof timestamp === 'string') {
        rx.lastIndex = 0;
        var g = rx.exec(timestamp);
        if (g) {
            var hours = g[1];
            var minutes = g[2];
            var seconds = g[4] || '0';
            var milliseconds = g[6] || '0';
            return getPureTime(+milliseconds + +seconds * oneSecond + +minutes * oneMinute + +hours * oneHour);
        }
        return 0;
    }
    else if (Array.isArray(timestamp)) {
        var hours = timestamp[0], minutes = timestamp[1], seconds = timestamp[2], milliseconds = timestamp[3];
        return getPureTime(+milliseconds + seconds * oneSecond + minutes * oneMinute + hours * oneHour);
    }
    else if (timestamp instanceof Date) {
        return timestamp.getTime() % oneDay;
    }
    return timestamp > 0 ? (timestamp > oneDay ? timestamp % oneDay : timestamp) : 0;
}
//# sourceMappingURL=common.js.map